<template>
	<section class="container">
		<section class="hero">
			<div class="hero-body">
				<div class="container has-text-centered">
					<h1 class="title has-text-primary is-uppercase is-2" data-cy="website-title">
						Terrassa tapiada
					</h1>
					<p class="subtitle is-4 has-text-dark has-text-centered mt-3" data-cy="website-description">Fotografia dels habitatges tapiats a Terrassa entre 2020 i 2021</p>
				</div>
			</div>
		</section>
		<LocationMap />
	</section>
</template>

<script>
import LocationMap from '@/components/LocationMap.vue'
export default {
	components: {
		LocationMap,
	}
}
</script>
